import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import BlackjackAreaController, {
  useBlackjackPlayers,
} from '../../../../classes/BlackjackAreaController';
import useTownController from '../../../../hooks/useTownController';

export default function WaitBlackjackGameModal({
  isOpen,
  blackjackAreaController,
}: {
  isOpen: boolean;
  blackjackAreaController: BlackjackAreaController;
}) {
  const townController = useTownController();
  const toast = useToast();
  const players = useBlackjackPlayers(blackjackAreaController);
  townController.pause();
  const names = [] as string[];
  const townPlayers = townController.players;
  players.forEach(eachPlayer => {
    const playerName = townPlayers.find(townPlayer => townPlayer.id === eachPlayer.id)?.userName;
    if (playerName) {
      names.push(playerName);
    }
  });
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        // closeModal();
        toast({ title: 'Cannot exit while in an active game', status: 'error' });
        townController.unPause();
      }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Waiting for host to start game... </ModalHeader>
        <ModalBody pb={6}>
          <Text>All players:</Text>
          <>
            {names.map(name => {
              return (
                <>
                  <Text>{name}</Text>
                </>
              );
            })}
          </>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
